import { useStaticQuery } from 'gatsby';
const useTheme = () => {
  const data = useStaticQuery(query);
  return data.theme;
};
export default useTheme;
const query = "3409670815";